import React from 'react';

import { EmptyPage } from 'apps/auth/components/common/Layout/EmptyPage/EmptyPage';

const EmptyAccounts = (props) => {
    return <EmptyPage iconName="card" emptyText={props.title} />;
};

export default EmptyAccounts;
